import { type AppRouter } from './routers/_app';
import { createClient, createFetchClient } from '@banzai/utils/trpc';

export const client = createClient<AppRouter>();
export const fetchClient = createFetchClient<AppRouter>();
